/*
 * Emote catalog. Wave / dance / sit — the three poses the canonical Critter
 * type already references on the `emote?` field.
 *
 * Server treats emote names as opaque strings (validated against EMOTE_NAMES
 * from /shared/protocol). The visual implementation per emote lives in
 * `render/emote.ts`.
 *
 * Pet-frame tone (per LORE.md): nothing here is a "taunt" or a "ready" —
 * these are warm gestures one critter makes toward another.
 */

import type { EmoteName } from '../../../shared/protocol';

export interface Emote {
  name: EmoteName;
  /** Display label in the picker UI. */
  label: string;
  /** A short cozy verb-line shown over the bubble area while emoting. */
  caption: string;
}

export const EMOTES: ReadonlyArray<Emote> = [
  { name: 'wave', label: '👋 Wave', caption: 'waves hello' },
  { name: 'dance', label: '💃 Dance', caption: 'sways a little' },
  { name: 'sit', label: '🪑 Sit', caption: 'sits down to rest' },
];

export function emoteByName(name: EmoteName): Emote {
  return EMOTES.find((e) => e.name === name) ?? EMOTES[0]!;
}
